// src/pages/MultilingualDashboard1.tsx
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateDashboardFields } from "../../../features/common/commonSlice";
import { languages } from "../../../features/upload/uploadSlice";
import { toast } from "react-toastify";

const MultilingualDashboard1: React.FC<{ finYear: string; meetingType: any }> = ({
  finYear,
  meetingType,
}) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [languageTable, setLanguageTableData] = useState<any[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDashboardData(finYear, meetingType?.value || 0);
  }, [finYear, meetingType, dispatch]);



  const fetchDashboardData = async (finYear: string, meetingType: string | number) => {
    try {
      const response = await axios.get(
        `${baseUrl}api/dashboard?fin_year=${encodeURIComponent(
          finYear
        )}&meeting_type=${encodeURIComponent(meetingType)}`

      );
      if (response?.data?.msg_code === 400) {
        toast.error(response?.data?.msg || "Something went wrong");
        setLanguageTableData([]);
        return;
      }

      setLanguageTableData(response?.data?.language_table || []);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setLanguageTableData([]);
    }
  };

  const handleMomHighlight = (lang: string, langDesc: string) => {
    dispatch(
      updateDashboardFields({
        menu: "Multilingual Coverage",
        fields: {
          meeting_language: lang,
          meeting_language_desc: langDesc,
          taskId: "",
        },
      })
    );
  };

  return (
    <div>
      <table className="table table-striped mt-3">
        <thead className="thead-cus">
          <tr>
            <th className="left-radius">S.No.</th>
            <th className="no-radius">Language</th>
            <th className="text-center no-radius">Total Meetings</th>
            <th className="text-center right-radius">Percentage</th>
          </tr>
        </thead>
        <tbody>
          {languageTable.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-center">
                No data available
              </td>
            </tr>
          ) : (
            languageTable.map((item, index) => {
              const langCode =
                languages.find(
                  (lang) =>
                    lang.label.toLowerCase() === item.meeting_language.toLowerCase()
                )?.code || "";

              return (
                <tr key={item.meeting_language}>
                  <td>{index + 1}</td>
                  <td

                    // className="highlight-td2"
                    // onClick={() => handleMomHighlight(langCode, item.meeting_language)}
                    style={{ cursor: "pointer" }}
                  >
                    {item.meeting_language}
                  </td>
                  <td className="text-center">{item.total_meetings}</td>
                  <td className="text-center">{item.percentage}%</td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MultilingualDashboard1;
